import apiClient from "./axios";

export const checkLink = (link) => {
   
   let response =  apiClient.post('participation/check-link', {link: link});
   return response 
}

export const storePhone = (phone) => {
    return apiClient.post('participation/store', {phone: phone});
}

export const uploadPhoto = (payload) => {

    const formData = new FormData();
    
    formData.append('photo', payload.photo);
    formData.append('link', payload.link);

    return apiClient.post('participation/upload-bottle-photo', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};


export const spinTheWheel = (payload) => {
     return apiClient.post('participation/spin-wheel', payload);
}


export const getGifts = () => {
    return apiClient.get('gifts');
}